export default "__VITE_ASSET__CtF0r804__"